'use client';

import {SearchProduct} from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import {useTranslations} from 'next-intl';
import Image from 'next/image';
import ProductItem from '../../../components/shop/ProductItem';
import {Link} from '@/i18n/routing';

interface IProps {
  products: SearchProduct[];
  landing: any;
}

export default function LandingContent(props: IProps) {
  const {landing, products} = props;
  const t = useTranslations('landing');

  return (
    <>
      <div className="section-container text-center">
        <div className="relative" style={{ height: '300px' }}>
          <Image
            fill
            src={landing.bannerImageUrl}
            style={{ maxHeight: '300px', objectFit: 'contain', width: '100%' }}
            alt={landing.title ? `${landing.title}` : ''}
          />
        </div>
        <h1 className="text-primary text-center mt-3">{landing.subtitle}</h1>
        {landing.cols && landing.cols.length > 0 && (
          <div
            className='grid grid-cols-1 md:grid-cols-3 flex-wrap md:flex-row flex-col mx-0 mb-4'>
            {landing.cols.map((col, idx) => (
              <div className='mt-4' key={idx}>
                <Image
                  fill
                  src={col.imageUrl}
                  style={{ maxWidth: '120px', objectFit: 'contain' }}
                  alt={col.label}
                />
                <h4 className='mt-3'>{col.label}</h4>
              </div>
            ))}
          </div>
        )}
        <h4 className='mb-5'>{landing.description}</h4>
        <div className='mb-5'>
          <div
            className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 items-stretch mx-0 justify-center'>
            {products &&
              products.map((product) => (
                <ProductItem
                  key={product.id}
                  hidePrice={true}
                  isShowOnly={false}
                  button={
                    <Link
                      className="inline-block w-full"
                      href={{
                        pathname: '/shop/[id]',
                        params: { id: product.id },
                      }}
                    >
                      <button className="w-full button leading-10 btn-md btn-primary-o product-btn">
                        {t('show-product')}
                      </button>
                    </Link>
                  }
                  product={product}
                />
              ))}
          </div>
        </div>
        { landing.buttonUrl &&
        <Link href={landing.buttonUrl}>
          <button className="button btn-md leading-10 btn-primary mb-4">
            {landing.buttonLabel}
          </button>
        </Link>
        }
      </div>
    </>
  );
}
